import styled from '@emotion/styled'

export const BaseRadioInput = styled.input`
  margin: 0;
  flex-shrink: 0;
  appearance: none;
  width: 20px;
  height: 20px;
  color: black;
  border: 2px solid black;
  border-radius: 50%;
  outline: none;

  &:before {
    content: '';
    display: block;
    width: 60%;
    height: 60%;
    margin: 20% auto;
    border-radius: 50%;
  }

  &:checked:before {
    background: black;
  }
`
